<template>
  <div class="">

    <Head />

    <div class="main listMain">

      <AccesskeyLink target="accesskey_c" accesskey="c" :aria-label="$t('跳到中央內容區塊')">
        {{ $t(':::') }}
      </AccesskeyLink>

      <!-- 毛毛蟲 -->
      <nav aria-label="breadcrumb" class="breadcrumb_box">
        <div class="container">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><router-link to="/" :title="$t('首頁')">{{ $t('首頁') }}</router-link></li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('時間票價') }}</li>
          </ol>
        </div>
      </nav>

      <div class="listMain_box">
        <div class="container">

          <div class="title_box">
            <h2>{{ $t('時間票價') }}</h2>
          </div>

          <div class="box">

            <div class="text_box">

              <div class="visitInfo_box">

                <h3 class="visitInfo_title">{{ $t('營業時間') }}</h3>

                <div class="openTime_box">

                  <table class="openTime_table">
                    <thead>
                      <tr>
                        <th class="week">{{ $t('星期') }}</th>
                        <th class="time">{{ $t('開館時間') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="week">{{ $t('星期一') }}</td>
                        <td class="time">{{ $t('09:00 – 17:00') }}</td>
                      </tr>
                      <tr>
                        <td class="week">{{ $t('星期二') }}</td>
                        <td class="time">{{ $t('09:00 – 17:00') }}</td>
                      </tr>
                      <tr>
                        <td class="week">{{ $t('星期三') }}</td>
                        <td class="time">{{ $t('休館') }}</td>
                      </tr>
                      <tr>
                        <td class="week">{{ $t('星期四') }}</td>
                        <td class="time">{{ $t('09:00 – 17:00') }}</td>
                      </tr>
                      <tr>
                        <td class="week">{{ $t('星期五') }}</td>
                        <td class="time">{{ $t('09:00 – 17:00') }}</td>
                      </tr>
                      <tr>
                        <td class="week">{{ $t('星期六') }}</td>
                        <td class="time">{{ $t('10:00 – 17:00') }}</td>
                      </tr>
                      <tr>
                        <td class="week">{{ $t('星期日') }}</td>
                        <td class="time">{{ $t('10:00 – 17:00') }}</td>
                      </tr>
                    </tbody>
                  </table>

                  <div class="note">
                    <p>{{ $t('最後售票時間及入園時間：16:30') }}</p>
                    <p>{{ $t('休園日：每週三、小年夜、除夕') }}</p>
                    <p class="required">{{ $t('※營運調整公告：自2026年1月1日起，隆田文化資產教育園區每週固定休園日，調整為「每週三」') }}</p>
                  </div>

                </div>



                <h3 class="visitInfo_title">{{ $t('票價資訊') }}</h3>

                <div class="admissionFee_box">
                  <table class="admissionFee_table">
                    <thead>
                      <tr>
                        <th>{{ $t('票種') }}</th>
                        <th class="fee">{{ $t('票價') }}</th>
                        <th class="target">{{ $t('適用對象') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td data-title="票種">{{ $t('全票') }}</td>
                        <td data-title="票價" class="fee">100</td>
                        <td data-title="適用對象" class="target">
                          <div>
                            <p>{{ $t('一般遊客') }}</p>
                          </div>

                        </td>
                      </tr>

                      <tr>
                        <td data-title="票種">{{ $t('優惠票') }}</td>
                        <td data-title="票價" class="fee">70</td>
                        <td data-title="適用對象" class="target">
                          <div>
                            <p>{{ $t('持有學生證在學學生。') }}</p>
                            <p>{{ $t('20人以上團體之成員。') }}</p>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td data-title="票種">{{ $t('半票') }}</td>
                        <td data-title="票價" class="fee">50</td>
                        <td data-title="適用對象" class="target">
                          <div>
                            <p>{{ $t('65歲以上長者。') }}</p>
                            <p>{{ $t('6歲以上未滿12歲之兒童。') }}</p>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td data-title="票種">{{ $t('免費') }}</td>
                        <td data-title="票價" class="fee">0</td>
                        <td data-title="適用對象" class="target">
                          <div>
                            <p>{{ $t('持有設籍於本市官田區之身分證明文件。') }}</p>
                            <p>{{ $t('未滿六歲之兒童。') }}</p>
                            <p>{{ $t('持有縣市政府依志願服務法之志願服務榮譽卡。') }}</p>
                            <p>{{ $t('持有交通部觀光局核發之導遊人員執業證。') }}</p>
                            <p>{{ $t('持有身心障礙證明，其本人與隨同1人。') }}</p>
                          </div>
                        </td>
                      </tr>

                    </tbody>
                  </table>

                  <div class="note">
                    <p>{{ $t('※凡購買優惠票、半票及免費票條件者，敬請出示相關證件，未攜帶者一律依全票計。') }}</p>
                    <p>{{ $t('※為鼓勵乘坐大眾交通運輸工具，如於園區服務台出示 T-Pass 或當日臺鐵隆田站下車之乘車證明或車票，即可享門票優惠價（70元）購票入園！') }}</p>
                  </div>
                </div>




              </div>



            </div>


          </div>


        </div>
      </div>

    </div>

    <Footer />

  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import Footer from '@/components/Footer.vue';

import AccesskeyLink from '@/views/AccesskeyLink.vue'

// 輪播
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
  name: 'VisitInfo',
  components: {
    Head,
    Footer,

    AccesskeyLink,

    VueSlickCarousel,
  },

  data() {
    return {




    };
  },

  methods: {


  },

}

</script>
